import { $ } from '../platform/dom';
import { DRAFT, craftCompletedBy } from '../sim/draft';
import { evolutionById } from '../data/evolutions';
import { unionById } from '../data/unions';
/* ============================================================
   抽卡的能動性工具列（Reroll / Banish，P1）
   ============================================================

   `03-in-run-progression.md` 第四節：這三個工具是「隨機性配上能動性」的
   具體實作。**Banish 比 Reroll 重要** —— reroll 只是再賭一次，
   banish 是編輯機率空間，玩家排掉不要的東西之後，後面每一輪的品質都會變好。
   那個持續的改善才是「我在建構」而不是「我在碰運氣」的來源。

   拆成獨立檔案是因為 `ui/levelup.ts` 已經接近專案的單檔上限，
   而這一段（工具列的渲染與剩餘次數顯示）跟卡片渲染沒有共用的狀態。

   Lock（鎖定一個選項到下次抽卡）**還沒做**：03 給它的初始值是 0，
   取得方式是局外強化解鎖，而局外的供給端要到 P4 才接。 */

/** 這一項拿了會湊齊哪一個進化／融合。回傳顯示用的名字。 */
export function craftLabelFor(id): string {
  var c = craftCompletedBy(id);
  if (!c) return '';
  var d: any = evolutionById(c) || unionById(c);
  return d ? d.n : c;
}

/** 畫工具列。Boss 獎勵那一組不畫（`isDraft` 為 false 時整條收起來）——
    那三張是定向發牌，重抽與排除都沒有意義。 */
export function drawDraftTools(isDraft: boolean, onReroll: () => void) {
  var el = $('upTools');
  if (!el) return;
  if (!isDraft) { el.innerHTML = ''; el.classList.remove('show'); return; }
  el.classList.add('show');
  var can = DRAFT.rerolls > 0;
  var html = '<button class="dtool' + (can ? '' : ' off') + '" id="btnReroll">' +
    '重抽 <b>' + DRAFT.rerolls + '</b><i>R</i></button>' +
    /* Banish 沒有自己的按鈕：它做在卡片的 ✕ 上（見 `ui/progress.ts`）。
       這裡只顯示剩餘次數，讓玩家知道那個 ✕ 還按得動幾次。 */
    '<span class="dtool ghost">排除 <b>' + DRAFT.banishes + '</b><i>卡片 ✕</i></span>';
  if (DRAFT.banished.length) {
    html += '<span class="dban">已排除 ' + DRAFT.banished.length + ' 項</span>';
  }
  el.innerHTML = html;
  var b = $('btnReroll');
  if (b && can) b.addEventListener('click', onReroll);
}
